var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.currentVersion, {
    ref: "dashboard",
    tag: "component",
    attrs: {
      cardData: _vm.cardData,
      sevenDays: _vm.sevenDays,
      channelLabels: _vm.channelLabels,
      channelValues: _vm.channelValues,
      topRate: _vm.topRate,
      topRatePercent: _vm.topRatePercent,
      topRateLabels: _vm.topRateLabels,
      bottomRate: _vm.bottomRate,
      bottomRatePercent: _vm.bottomRatePercent,
      bottomRateLabels: _vm.bottomRateLabels,
      topOrgs: _vm.topOrgs,
      topAgents: _vm.topAgents,
      loading: _vm.loading,
      lineGraphLabel: _vm.lineGraphLabel,
      sevenDaysNotEmpty: _vm.sevenDaysNotEmpty,
      successDate: _vm.successDate,
      failDate: _vm.failDate,
      channelDate: _vm.channelDate,
      numberOfDecimal: _vm.numberOfDecimal,
      smsCountValues: _vm.smsCountValues,
      agentsValues: _vm.agentsValues,
      paymentYesterdayLabels: _vm.paymentYesterdayLabels,
      paymentYesterdayValues: _vm.paymentYesterdayValues,
      smsColor: _vm.smsColor,
      agentsColor: _vm.agentsColor,
      paymentColor: _vm.paymentColor,
      sevenDaysColor: _vm.sevenDaysColor
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }